export interface TokenResult {
  success: boolean;
  token: string; // jwt token
  refreshToken: string;// refresh token
  refreshTokenExpiry: number;  // refresh token expiry
  roles: string | string[]; // user role
  username: string;
  name: string;
  givenName: string;
  userId: string;
  raygunKey: string;

  cannotAccessPreRelease: boolean;
  productionSite: string;

  userNotFound: boolean; // user was not found

  returnUrl: string;
}

export class TokenResultClass implements TokenResult {
    success: boolean;
    token: string;
    refreshToken: string;
    refreshTokenExpiry: number;
    roles: string | string[];
    username: string;
    name: string;
    givenName: string;
    userId: string;
    raygunKey: string;
    cannotAccessPreRelease: boolean;
    productionSite: string;
    userNotFound: boolean;
    returnUrl: string;

    constructor(success: boolean) {
        this.success = success;
    }
}